import clsx from 'clsx';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../../LinkyLinky';
import { T } from '../../../../../../../Translations';
import LearningPlatformIcon from '../../../../../../Cutesies/LearningPlatformIcon';

const LearningPlatformLink: React.FC = () =>
  findLink('learning-platform-app', currentUserStore.links)
    .map((link) => (
      <li className={'flex no-underline relative font-semibold cursor-pointer'}>
        <a
          href={link.href}
          rel="noopener noreferrer"
          data-intercom-target="learning-platform-navigation"
          className={clsx(
            'justify-items-start px-3',
            'flex justify-around',
            'items-center text-xs leading-6 text-gray-900 hover:text-teal-600',
          )}
        >
          <span className="h-10 m-2">
            <LearningPlatformIcon />
          </span>
          <span className="pl-3 text-lg">
            <T kind="Learning" />
          </span>
        </a>
      </li>
    ))
    .getOrElse(() => <></>);

export default observer(LearningPlatformLink);
